// extracted by mini-css-extract-plugin
module.exports = {"button_right":"AddRecipients_button_right_1ICPq"};